import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";

function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  // Redirect if already logged in
  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn") === "true") {
      navigate("/");
    }
  }, [navigate]);

  const handleSignup = (e) => {
    e.preventDefault();

    if (!email || !password || !confirmPass) {
      toast.error("Please fill all fields");
      return;
    }

    if (password !== confirmPass) {
      toast.error("Passwords do not match");
      return;
    }

    // Simulated account storage (if later needed for verification)
    sessionStorage.setItem("userEmail", email);
    sessionStorage.setItem("isLoggedIn", "true");

    toast.success("Account created successfully!");
    navigate("/");
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2 className="login-title">Create Account</h2>
        <p className="login-sub">Join us and enjoy seamless shopping</p>

        <form onSubmit={handleSignup}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Re-enter password"
              className="input"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-login">
            Create Account
          </button>
        </form>

        <p className="helper-text">
          Already have an account? <Link to="/login-now">Sign In</Link>
        </p>
      </div>

      {/* INLINE STYLES */}
      <style>{`
        .login-wrapper {
          min-height: 100vh;
          display:flex;
          justify-content:center;
          align-items:center;
          background:#f5f7fa;
        }

        .login-card {
          background:white;
          width:380px;
          padding:35px;
          border-radius:15px;
          box-shadow:0px 20px 40px rgba(0,0,0,0.08);
          text-align:center;
        }

        .login-title {
          font-size:26px;
          font-weight:700;
          margin-bottom:5px;
          color:#111;
        }

        .login-sub {
          color:#777;
          margin-bottom:25px;
        }

        .form-group {
          text-align:left;
          margin-bottom:18px;
        }

        .form-group label {
          font-size:14px;
          margin-bottom:6px;
          display:block;
          font-weight:600;
        }

        .input {
          width:100%;
          padding:12px;
          border:1px solid #ddd;
          border-radius:10px;
          outline:none;
          font-size:15px;
        }

        .input:focus {
          border-color:#007bff;
          box-shadow:0 0 0 2px rgba(0,123,255,0.15);
        }

        .btn-login {
          width:100%;
          background:#007bff;
          padding:12px;
          color:white;
          font-weight:bold;
          border:none;
          border-radius:10px;
          cursor:pointer;
          transition:.3s;
          margin-top:10px;
        }

        .btn-login:hover {
          background:#005dd4;
        }

        .helper-text {
          margin-top:18px;
          color:#555;
          font-size:14px;
        }

        .helper-text a {
          color:#007bff;
          font-weight:600;
          text-decoration:none;
        }
      `}</style>
    </div>
  );
}

export default Signup;
